import { Controller } from "stimulus"

export default class extends Controller {

    static targets = ["abuse", "error"]

    select_error() {
        this.abuseTargets.forEach((el, i) => {
            el.classList.add("toggle--hide")
        })

        this.errorTargets.forEach((el, i) => {
            el.classList.remove("toggle--hide")
        })
    }

    select_abuse() {
        this.abuseTargets.forEach((el, i) => {
            el.classList.remove("toggle--hide")
        })

        this.errorTargets.forEach((el, i) => {
            el.classList.add("toggle--hide")
        })
    }
}